
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.6 92.3c0-6.1.1-12.1 0-18.2 0-2 .7-2.5 2.5-2.5 3.4.1 6.8 0 10.2.1 2 .1 2.5-.7 2.5-2.6-.1-3.8-.1-7.6 0-11.4 0-1.7-.5-2.5-2.3-2.4-3.6.1-7.1 0-10.7.1-1.6 0-2.1-.5-2.1-2.1.1-7.1.1-14.2 0-21.4 0-1.7.9-2.4 2.1-3.2C23.5 20.1 38.3 11.6 53 3c.3-.2.6-.3.8-.5 4.3-4 8-2.9 12.7.2 17.3 11.3 35 22.2 52.5 33.1 1.7 1.1 2.4 2.2 2.4 4.3-.1 10.8-.1 21.7 0 32.5 0 2-.6 2.7-2.6 2.6-3.6-.1-7.1 0-10.7-.1-1.6 0-2.4.4-2.3 2.2.1 4 .1 7.9 0 11.9 0 1.7.6 2.3 2.3 2.3 3.6-.1 7.1 0 10.7 0 1.5 0 2.2.4 2.1 2.1-.1 5.6-.1 11.2 0 16.8 0 1.9-.8 2.5-2.4 3-14.6 4.6-29.2 9.2-43.8 14-3.2 1-5.7.8-8.7-.4-11.2-4.5-22.4-8.8-33.6-13.2-1.2-.5-2.5-.7-3.8-.7-6.5-.1-13-.1-19.4 0-2.3.1-2.9-.8-2.8-2.9.3-6 .2-12 .2-17.9zm9-51.6c1.1-.3 2-.5 2.9-.8 11.1-3.7 22.2-7.3 33.3-11.2 2.6-.9 4.6-.6 6.8.9 6.4 4.6 13 9 19.6 13.4 2.2 1.5 2.7 3.4 1.3 5.8-1.6 2.8-3.4 3.4-6 1.9-2.7-1.6-5.3-3.4-8-5.1-3-1.9-5.1-1.3-7.3 1.9-2 2.9-1.7 5 1.2 7C66.2 59.3 73.1 64 80 68.6c.9.6 2.2 1 3.4 1 8.9.1 17.8 0 26.7.1 1.9 0 2.7-.4 2.7-2.5-.1-7.8-.1-15.7 0-23.5 0-1.5-.5-2.3-1.7-3.1-16.7-9.9-33.5-19.9-50.2-29.9-1.6-1-2.9-.9-4.4 0L18.7 32.9c-4 2.1-4.3 2.9-3.1 7.8zM83.7 98h-27c-2.9 0-4.4-1.8-4.4-4.9.1-2.9 1.2-4 4.2-4 4.3 0 8.6.1 12.9-.1 3.2-.1 4.7-1.9 4.7-5.2 0-2.9-2.2-5.2-5-5.2H17.4c-1.7 0-2.3.5-2.3 2.2.1 7.5.1 15.1 0 22.6 0 1.8.6 2.4 2.4 2.4 5.7-.1 11.5-.1 17.2 0 1.3 0 2.6.2 3.8.7 9.8 3.8 19.6 7.6 29.3 11.5 2 .8 3.6.8 5.6.2 12.2-4.1 24.5-8.1 36.8-12.1 2.2-.7 3.3-1.7 2.9-4.1-.1-.5-.1-1 0-1.5.2-1.9-.5-2.5-2.4-2.5-9.1.1-18.1 0-27 0z"}})])
          )
        }
      }
    